import { useQuery } from 'react-query';
import { AgeGroupAPI } from 'api/admin/ageGroup';

export default function useAgeGroup(competitionId) {
  return useQuery(['ageGroups', competitionId], () =>
    AgeGroupAPI.getAll(competitionId)
  );
}
